<template>
    <div>
        <v-card>

            <v-row class="align-center">

                <v-col cols="12" md="4" sm="12">
                    <v-card-title>Live Rates Logs</v-card-title>
                </v-col>

                <v-col cols="12" md="8" sm="12">
                    <div class="d-flex flex-column flex-sm-row justify-end gap-2 px-4">
                        <DateTimeFilterModal @onSelectDateTime="selectDateTime" />
                        <v-select
                            :items="statusOptions"
                            v-model="selectedStatus"
                            label="Status"
                            style="max-width: 150px"
                            dense
                            class="mr-2"
                            :disabled="!integrationActive"
                            @change="onStatusChange"
                        ></v-select>
                        <v-select
                            :items="errorTypeOptions"
                            v-model="selectedErrorLabel"
                            label="Error Type"
                            style="max-width: 220px"
                            dense
                            class="mr-2"
                            :disabled="!integrationActive"
                            @change="onErrorTypeChange"
                        ></v-select>
                        <v-text-field append-icon="search" label="To postcode or suburb" single-line
                            style="max-width: 300px" dense :value="search" @keyup="onSearch($event)">
                        </v-text-field>
                    </div>
                </v-col>

            </v-row>

            <div v-if="errorInfo" class="p-3">
                <v-alert type="error">
                    {{ errorInfo }}
                </v-alert>
            </div>

            <div v-else-if="items">
                <v-row v-if="selectedRecords && selectedRecords.length > 0" class="d-none d-sm-flex">
                    <v-col>
                        <v-col class="subactions d-flex flex-row justify-start align-center">
                            <v-btn x-small @click="onExportBatch()">export</v-btn>
                        </v-col>
                    </v-col>
                </v-row>

                <v-data-table

                    :headers="headers"
                    :options.sync="options"
                    :server-items-length="nextPage"
                    :footer-props="{'items-per-page-options': [10, 25, 50, 100]}"
                    :items="items"
                    :search="search"
                    :loading="loading"
                    :disable-sort="false"
                    :show-select="isAdmin"
                    v-model="selectedRecords"
                    loading-text="Loading... Please wait"
                    class="sticky-headers">

                    <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                        <v-simple-checkbox
                            :value="isSelected"
                            :disabled="loading"
                            @input="select($event);"
                        ></v-simple-checkbox>
                    </template>

                    <!-- integration -->
                    <template v-slot:[`item.integration.label`]="{ item }">
                    <router-link class="text-dark" :to="{name: 'integration edit', params:{id: item.integration.id}}">
                        {{ item.integration.label }}
                    </router-link>
                    <v-tooltip right>
                        <template v-slot:activator="{ on }" v-if="item.is_test == 1">
                            <img v-on="on" src="/images/test_mode.png" class="mode_icon"></img>
                        </template>
                        <span>Test Mode</span>
                    </v-tooltip>
                    </template>

                    <!-- status -->
                    <template v-slot:[`item.status`]="{ item }">
                    <v-chip :color="liveRateStatusColor(item.status_text)" :text-color="liveRateStatusTextColor(item.status_text)" :style="'border: 1px solid ' + liveRateStatusBorderColor(item.status_text)" x-small>{{ item.status_text }}</v-chip>
                    </template>

                    <template v-slot:[`item.is_delayed`]="{ item }">
                    <v-chip color="#7E2501" text-color="white" style="border: 1px solid #7E2501" x-small v-show="item.is_delayed">TRUE</v-chip>
                    </template>

                    <!-- error type with tooltip -->
                    <template v-slot:[`item.error_type`]="{ item }">
                    <div v-if="item.error_type">
                        <v-menu right max-width="480" open-on-hover eager :close-on-content-click="false" offset-x content-class="error-tooltip-container">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip v-on="on" v-bind="attrs" color="#7E2501" text-color="white" style="border: 1px solid #7E2501" x-small>
                            {{ item.error_type }}
                            </v-chip>
                        </template>
                        <v-card class="error-tooltip pa-3 elevation-6">
                            <div class="d-flex align-center mb-2">
                            <v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
                            <span class="font-weight-medium">{{ item.error_type }}</span>
                            </div>
                            <div class="text-body-2">
                            <span class="label">Error</span>: {{ item.error_message || 'N/A' }}
                            </div>
                            <div class="text-body-2 mt-1">
                            <span class="label">Solution</span>:
                            <span v-if="item.error_solution" v-html="markdownToAnchor(item.error_solution)"></span>
                            <span v-else>N/A</span>
                            </div>
                        </v-card>
                        </v-menu>
                    </div>
                    <span v-else>-</span>
                    </template>

                    <!-- view data -->
                    <template v-slot:[`item.all_pop_up_data`]="{ item }">
                    <v-btn x-small :to="'/live-rates/logs/' + item.id">View Data</v-btn>
                    </template>


                </v-data-table>
            </div>
        </v-card>

    </div>
</template>
<style scoped type="text/css">
    .mode_icon {
        width: 15px;
        margin-top: -5px;
    }
    .filter-container {
        margin-left: 64px !important;
        margin-right: 64px !important;
    }
    .error-tooltip {
        max-width: 480px;
        white-space: normal;
        word-break: break-word;
        background-color: rgba(255, 255, 255, 0.92);
        color: #121212;
        border: 0 !important;
        /* Bottom-biased, softer shadow to avoid visible corner halos */
        box-shadow:
            0 24px 48px -16px rgba(0, 0, 0, 0.42),
            0 12px 24px -18px rgba(0, 0, 0, 0.28) !important;
        border-radius: 12px;
    }
    .error-tooltip .label {
        font-weight: 600;
        color: #616161;
        text-transform: none;
    }
    /* Remove default v-tooltip grey box and border; let our white card handle visuals */
    .error-tooltip-container {
        background-color: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 0 !important;
    }
</style>
<script>
import { EventBus } from '../../event-bus.js'
import DateTimeFilterModal from './modals/DateTimeFilterModal'

export default {
    components: {
        DateTimeFilterModal
    },
    data() {
        return {
            isAdmin: this.$store.getters.isAdmin,
            loading: true,
            search: '',
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Integration', value: 'integration.label', sortable: false },
                { text: 'From', value: 'from', sortable: false },
                { text: 'To', value: 'to', sortable: false },
                { text: 'No. Quotes', value: 'no_of_quotes', sortable: false },
                { text: 'Status', value: 'status', sortable: false},
                { text: 'Delayed', value: 'is_delayed', sortable: false},
                { text: 'Error Type', value: 'error_type', sortable: false },
                { text: 'Request received at', value: 'created_at', sortable: false},
                { text: 'Responded at', value: 'responded_at', sortable: false},
                { text: 'Actions', value: 'all_pop_up_data', sortable: false},
            ],
            items: [],
            timer: null,
            selectedStatus: 'all',
            statusOptions: [
                { text: 'All', value: 'all' },
                { text: 'Success', value: 'success' },
                { text: 'Fail', value: 'fail' },
                { text: 'Processing', value: 'processing' },
                { text: 'Skipped', value: 'skipped' },
                { text: 'Fallback', value: 'fallback' }
            ],
            selectedErrorLabel: 'all',
            errorTypeOptions: [{ text: 'All', value: 'all' }],
            // cache to keep Error Type list stable across empty result sets
            errorLabelsAllCache: [],

            options: this.getPaginateOptions(),
            pagination: { total: 0 },
            errorInfo: null,
            zIndex: 999,
            revert_page: false,
            set_page: 0,
            actvPage: 0,
            trackPage: 0,

            selectedDateTime: {
                startDate: null,
                endDate: null,
            },

            selectedRecords: [],

            integrationFilter: null,
        }
    },

    mounted() {
        if (!this.isAdmin) {
            let user = this.$store.getters.getUser
            if (!user.integration_ids || user.integration_ids.length <= 0) {
                this.errorInfo = "This account does not have any integrations"
                return
            }
        }

        this.options.sortBy = ['id'];
        this.options.sortDesc = [true];
        this.options.page = this.$route.query.page ? this.$route.query.page : 1;

        const {
            filter,
            search,
            startDate,
            endDate,
        } = this.$route.query

        this.integrationFilter = filter || this.integrationActive

        this.search = search
        this.selectedDateTime.startDate = startDate
        this.selectedDateTime.endDate = endDate
    },

    watch: {
        integrationActive(to, from) {
            if (to != from) {
                if (!this.$route.query.filter) {
                    this.integrationFilter = to
                }
                this.revert_page = true;
                this.fetchPage();
            }
        },

        params(val, oldVal) {
            // this is to avoid redundant request
            if (JSON.stringify(val) != JSON.stringify(oldVal)) {
                if (!this.revert_page) {
                    // vuetify pagination bug
                    // condition for pagination string into integer
                    if (this.set_page > 0 && !this.actvPage) {
                        let valPage = val.page ?? null;
                        if (valPage.length > 1) {
                            this.set_page = this.set_page + parseInt(valPage[1]);
                            this.actvPage = this.set_page;
                        }
                    }
                    this.fetchPage();
                }
            }
        },
    },

    computed: {
        params(nv) {
            return {
                ...this.options,
                query: this.search,
                error_label: this.selectedErrorLabel
            };
        },

        integrationActive() {
            return this.$store.getters.getActiveIntegration;
        },


        nextPage() {
            return (this.options.page * this.items.length) + 1
        },
    },

    methods: {

        onExportBatch() {

            const records = this.selectedRecords;
            const header = [
                'ID',
                'Integration',
                'From',
                'To',
                'No. Quotes',
                'Status',
                'Is Delayed',
                'Error Type',
                'Request received at',
                'Responded at',
            ]

            let csvContent = '';
            csvContent += header.join(',') + '\n';
            records.forEach(record => {
                let row = [
                    record.id,
                    `"${record.integration.label}"`,
                    `"${record.from}"`,
                    `"${record.to}"`,
                    record.no_of_quotes,
                    record.status_text,
                    record.is_delayed ? 'TRUE' : 'FALSE',
                    `"${record.error_type || ''}"`,
                    `"${record.created_at}"`,
                    `"${record.responded_at}"`,
                ];
                csvContent += row.join(',') + '\n';
            });


            const url = window.URL.createObjectURL(new Blob([csvContent], {type: "text/csv"}))
            const pwa = window.open(url)

            if (!pwa || pwa.closed || typeof pwa.closed === 'undefined') {
                EventBus.$emit('show-error', 'Please disable your pop-up blocker and try again.')
                return
            }
        },

        selectDateTime(startDate, endDate) {
            this.selectedDateTime = { startDate: startDate, endDate: endDate}
            this.fetchPage()
        },

        onSearch(e) {

            let text = e.target.value;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = text;
                this.options.page = 1;
                this.fetchPage();
            }, 800);
        },

        fetchPage() {
            this.loading = true;
            let params = this.prepareParams(this.options, this.search);
            let query = {};
            let pageOption = Number(this.options.page);

            // Add status filter
            if (this.selectedStatus && this.selectedStatus !== 'all') {
                params.status = this.selectedStatus;
                query.status = this.selectedStatus;
            }

            // Add error type filter (by label)
            if (this.selectedErrorLabel && this.selectedErrorLabel !== 'all') {
                params.error_label = this.selectedErrorLabel;
                query.error_label = this.selectedErrorLabel;
            }

            if (typeof this.$route.query.page !== 'undefined' && pageOption > 1 && !this.set_page) {
                this.set_page = parseInt(pageOption);
            }

            // check for more page higher than 1
            if (this.options.page > 1) {
                query.page = this.options.page;
            }

            if (this.integrationFilter) {
                params.integration_ids = [this.integrationFilter];
                query.filter = this.integrationFilter;
            }

            if (this.revert_page) {
                params.page = 1;
                query.page = 1;
                this.options.page = 1;
            }

            if (this.actvPage > 0) {
                params.page = this.actvPage;
                query.page = this.actvPage;
                this.options.page = this.actvPage;

                // stopper double api request
                if (this.trackPage == 1) {
                    return;
                }
                this.trackPage++;
            }

            if(this.search) {
                params.search = this.search
                query.search = this.search
            }

            if(this.selectedDateTime.startDate) {
                params.startDate = this.selectedDateTime.startDate
                query.startDate = this.selectedDateTime.startDate
            }

            if(this.selectedDateTime.endDate) {
                params.endDate = this.selectedDateTime.endDate
                query.endDate = this.selectedDateTime.endDate
            }

            let queryParams = Object.keys(query).length === 0 ? '/live-rates/logs' : '?' + new URLSearchParams(query);
            window.history.pushState(query, null, queryParams);

            this.$http
                .get('/api/live-rates', { params })
                .then(({data}) => {
                    // map data to items
                    this.items = data.data.map(item => {
                        let map = item.attributes;
                        map.id = item.id;
                        map.error_type = map.error_type || map.error_code || '';
                        return map;
                    })

                    // Build error type options from transformer (full list); fallback to current items; keep selection even if not present
                    let labelsAll = [];
                    try {
                      const first = (data.data && data.data[0]) ? data.data[0] : null;
                      labelsAll = (first && first.attributes && Array.isArray(first.attributes.error_labels_all))
                        ? first.attributes.error_labels_all
                        : [];
                    } catch (e) { /* ignore */ }
                    // Refresh cache when backend provides list
                    if (Array.isArray(labelsAll) && labelsAll.length) {
                      this.errorLabelsAllCache = labelsAll.slice();
                    }
                    // Choose a stable source: cache -> backend list -> current items -> previous options
                    let sourceLabels = [];
                    if (this.errorLabelsAllCache.length) {
                      sourceLabels = this.errorLabelsAllCache.slice();
                    } else if (labelsAll.length) {
                      sourceLabels = labelsAll.slice();
                    } else if (this.items.length) {
                      sourceLabels = Array.from(new Set(this.items.map(i => i.error_type).filter(l => l && l !== '')));
                    } else {
                      sourceLabels = this.errorTypeOptions.filter(o => o.value !== 'all').map(o => o.value);
                    }
                    sourceLabels = Array.from(new Set(sourceLabels));
                    this.errorTypeOptions = [{ text: 'All', value: 'all' }, ...sourceLabels.map(l => ({ text: l, value: l }))];
                    // Do NOT reset to 'All' when the selected label is not in the list;
                    // keep current selection and let the server return an empty dataset for unknown filters.

                    this.pagination = data.meta.pagination;
                    this.loading = false;
                    this.revert_page = false;
                    this.actvPage = 0;
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                    this.loading = false;
                })
        },
        onStatusChange() {
            this.options.page = 1;
            this.fetchPage();
        },
        onErrorTypeChange() {
            this.options.page = 1;
            this.fetchPage();
        },
        markdownToAnchor(str) {
                 if (!str) return '';
            try {
                let s = String(str);

                // Convert markdown links [text](https://url)
                s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
                // Convert phrases like "please click here: https://url" or "click here: https://url" to masked anchors
                s = s.replace(/((?:please\s+)?click\s+here)\s*:?\s*(https?:\/\/[^\s<)]+)/gi, '<a href="$2" target="_blank" rel="noopener">$1</a>');

                // Deliberately do NOT auto-link other bare URLs to avoid breaking already-formed anchors/hrefs
                return s;
            } catch (e) {
                return str;
            }
        }
    },
}
</script>
